/* unplugin-vue-components disabled */import { render } from "./OpenQuestionQuizPlayer.vue?vue&type=template&id=c5a37cb2&ts=true"
import script from "./OpenQuestionQuizPlayer.vue?vue&type=script&lang=ts"
export * from "./OpenQuestionQuizPlayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__